import { useState, useRef, useEffect, useCallback } from "react";
import { yesterdayInBogota, validateVipUsageFilters } from "modules/came/model/vipUsageDates";
import { getVipUsageService } from "modules/came/services/vipUsageService";
const initialFilters = () => ({
  startDate: yesterdayInBogota(),
  endDate: yesterdayInBogota(),
  plate: "",
  groupId: "",
});
export default function useUsoVip() {
  const [filters, setFilters] = useState(initialFilters),
    firstFilters = useRef(filters);
  const [appliedFilters, setAppliedFilters] = useState(filters),
    [report, setReport] = useState(null),
    [groups, setGroups] = useState([]),
    [loading, setLoading] = useState(false),
    [error, setError] = useState(null);
  const request = useRef(null);
  const loadData = useCallback(async (next) => {
    request.current?.abort();
    const controller = new AbortController();
    request.current = controller;
    const current = () => request.current === controller && !controller.signal.aborted;
    const snapshot = { ...next };
    setReport(null);
    setError(null);
    const invalid = validateVipUsageFilters(snapshot);
    if (invalid) {
      setError(invalid);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const result = await getVipUsageService(snapshot, controller.signal);
      if (!current()) return;
      if (!result.success) throw new Error(result.error || "No se pudo consultar Uso de VIP.");
      setReport(result.report);
      setAppliedFilters(snapshot);
      setGroups(
        [...result.report.groups].sort((a, b) =>
          String(a.name || "").localeCompare(String(b.name || ""), "es", { numeric: true })
        )
      );
    } catch (err) {
      if (current()) setError(err.message);
    } finally {
      if (current()) setLoading(false);
    }
  }, []);
  useEffect(() => {
    loadData(firstFilters.current);
    return () => {
      request.current?.abort();
      request.current = null;
    };
  }, [loadData]);
  const updateFilters = useCallback(
    (values) => setFilters((previous) => ({ ...previous, ...values })),
    []
  );
  const resetFilters = useCallback(() => {
    const next = initialFilters();
    setFilters(next);
    loadData(next);
  }, [loadData]);
  return {
    filters,
    appliedFilters,
    report,
    groups,
    loading,
    error,
    updateFilters,
    resetFilters,
    applyFilters: () => loadData(filters),
    refresh: () => loadData(appliedFilters),
  };
}
